import React from 'react';
import { Switch, Route, Redirect } from "react-router-dom";
import styles from './Oglasi.module.css';
import OglasiNav from './OglasiNav';
import OglasiList from './OglasiList';
import Breadcrumb from './Breadcrumb';

const Oglasi = (props) => {
  if (props.location.pathname === '/oglasi') {
    return <Redirect to="/oglasi/godina/1" />
  }

  return (
    <>
      <Breadcrumb path={['Početna', 'Oglasi']} />
      <div className={styles.oglasiContent}>
        <OglasiNav />
        <Switch>
          <Route path="/oglasi/godina/:id" exact component={OglasiList} />
        </Switch>
      </div>
    </>
  );
}

export default Oglasi;